import ProfessionalLogin from './ProfessionalLogin';

export default ProfessionalLogin;